import { Box } from "@mui/material"
import { icons } from "../../../../../../utils/icons"
import { useContextState } from "../../../../../../hooks/theme"


export const CheckCell = ( { value } : { value:boolean } ) => {

    const { colors } = useContextState()

    return (
        <Box sx={{
            '& .MuiSvgIcon-root':{
                color: value ? colors.color8 : colors.color28
            },
            
        }}>
            { value ? icons('checkBox') : icons('disabledDefault')}
        </Box>
    )
}